import { ExpandableSection, FormField, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import { mdiAlert, mdiCheckCircle } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';

interface LicencesProp {
  licences?: any[];
}
const Licences: React.FC<LicencesProp> = ({
  licences = []
}) => {

  return (
    licences.map((licence: {
      licenceType: string;
      licenceNumber: string;
      ratings: any[];
      dateIssued: string;
      dateExpires: string;
      observations: string;
      valid: boolean;

    }, index: number) => (
      <ExpandableSection
        headerCounter={licence.ratings.length > 0 ? licence.ratings.length.toString() : undefined}
        headerActions={
          !licence.valid ? <Icon path={mdiAlert} size={1} color='red' /> : <Icon color='green' path={mdiCheckCircle} size={1} />
        }
        headerText={`#${licence.licenceNumber} - ${licence.licenceType}`}
        headerDescription={`Emitida: ${licence.dateIssued} | Expira: ${licence.dateExpires}
                                                                }`}
      >
        <SpaceBetween direction='vertical' size='s'>
          {licence.observations && <StatusIndicator type="not-started">{licence.observations}</StatusIndicator>}

          {licence.ratings.length === 0 ? <StatusIndicator type="info">Licencia no tiene habilitaciones</StatusIndicator> :
            licence.ratings.map((rating, index) => (
              <FormField info={`${rating.rating}`} key={index}
                label={!rating.valid ? <Icon path={mdiAlert} size={1} color='red' /> : <Icon color='green' path={mdiCheckCircle} size={1} />}
              >
                {rating.dateIssued} - {rating.dateExpires}
              </FormField>
            ))
          }
        </SpaceBetween>
      </ExpandableSection>

    ))
  );
};

export default Licences;